<div class="print-container">
    <h1 class="page-label">Upload Product Information</h1>
</div>

<div class="tab-pane">
    <div>
        <div class="print-container">
            <div class="row">
                <label class="col-sm-3 input-label" for="portal-input">CSV File:</label>
                <input id="dopv-orderName" class="col-sm-6 form-control" type="text" [ngModel]="selectedFile?.name" [readonly] [disabled] />

                <button class="btn btn-ef col-sm-3" type="button" (click)="selectFileClicked()">Select CSV File</button>
                <input type="file" #csvFile (change)="onSelectedFileChanged($event)" style="display:none" accept=".csv"/>
            </div>
            <div class="row">
            </div>
        </div>
    </div>
</div>

<div class="print-container">
    <div class="row">
        <button (click)="uploadClicked()" class="submit btn btn-primary col-sm-3" [disabled]="this.isUploading || this.selectedFile == null" >Upload File</button>
    </div>
    <div *ngIf="userMessage != null" class="row">
        <h3 [class.api-result-error]="isErrorMessage" [class.api-result-success]="!isErrorMessage">
            {{ userMessage }}
        </h3>
    </div>
</div>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog
    >
</ef-simple-indefinite-progress-dialog>
